/* tslint:disable */
/* eslint-disable */
/**
 * Ship to ship api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ActivationPositionSchema } from './ActivationPositionSchema';
import {
    ActivationPositionSchemaFromJSON,
    ActivationPositionSchemaFromJSONTyped,
    ActivationPositionSchemaToJSON,
} from './ActivationPositionSchema';

/**
 * Schema for a vessel in an S2S pair.
 * @export
 * @interface S2SVesselSchema
 */
export interface S2SVesselSchema {
    /**
     * Maritime Mobile Service Identity
     * @type {number}
     * @memberof S2SVesselSchema
     */
    mmsi?: number | null;
    /**
     * Name of the vessel
     * @type {string}
     * @memberof S2SVesselSchema
     */
    vesselName?: string | null;
    /**
     * IMO number
     * @type {number}
     * @memberof S2SVesselSchema
     */
    imo?: number | null;
    /**
     * GeoJSON Point of the vessel at activation time
     * @type {ActivationPositionSchema}
     * @memberof S2SVesselSchema
     */
    activationPosition?: ActivationPositionSchema;
    /**
     * GeoJSON Point of the vessel when the event fired
     * @type {ActivationPositionSchema}
     * @memberof S2SVesselSchema
     */
    firedPosition?: ActivationPositionSchema;
}

/**
 * Check if a given object implements the S2SVesselSchema interface.
 */
export function instanceOfS2SVesselSchema(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function S2SVesselSchemaFromJSON(json: any): S2SVesselSchema {
    return S2SVesselSchemaFromJSONTyped(json, false);
}

export function S2SVesselSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): S2SVesselSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mmsi': !exists(json, 'mmsi') ? undefined : json['mmsi'],
        'vesselName': !exists(json, 'vessel_name') ? undefined : json['vessel_name'],
        'imo': !exists(json, 'imo') ? undefined : json['imo'],
        'activationPosition': !exists(json, 'activation_position') ? undefined : ActivationPositionSchemaFromJSON(json['activation_position']),
        'firedPosition': !exists(json, 'fired_position') ? undefined : ActivationPositionSchemaFromJSON(json['fired_position']),
    };
}

export function S2SVesselSchemaToJSON(value?: S2SVesselSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mmsi': value.mmsi,
        'vessel_name': value.vesselName,
        'imo': value.imo,
        'activation_position': ActivationPositionSchemaToJSON(value.activationPosition),
        'fired_position': ActivationPositionSchemaToJSON(value.firedPosition),
    };
}

